export const pathes = {
    DEFAULT: "/",
    LOGIN: "/login",
    OPERATOR_PANEL: "/",
    ACTIVE_ORDERS: "/active-orders",
    NOT_FOUND: "not-found",
    BASE_PATH: "/driver",
    ORDER_DETAILS_WARNING: "/order-details/warning",
    ORDER_DETAILS_WAITING: "/order-details/waiting",
    ORDER_DELIVERED: "/order-details/delivered",
    ORDER_CANCELED: "/order-details/canceled",
    ORDER:"/order/:orderId",
    PAST_ORDERS: "/past-orders",
    EDIT_ORDERS: "/edit-orders/:orderId",
    SUPPORT: "/support",
    LOCATION_OF_COLLECTION: "/location",
    BATH_PATH:"/driver"
};
